<template>
  <section id="locations">
    <section-container class="pt-16 pb-8">
      <text-h2 class="text-center text-2xl mt-10 mb-12">Location</text-h2>
      <div class="flex justify-center">
        <div class="max-w-4xl w-full">
          <div class="bg-gray-50 rounded-lg overflow-hidden shadow-lg">
            <div class="grid md:grid-cols-3 gap-0">
              <div class="md:col-span-2 p-8">
                <div class="text-center">
                  <h3 class="text-2xl font-semibold text-gray-900 mb-4">
                    Regional Neurological Associates
                  </h3>
                  <div class="space-y-4">
                    <div class="flex items-center justify-center">
                      <svg class="w-5 h-5 text-gray-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                      </svg>
                      <p class="text-lg text-gray-700">
                        4256 Bronx Blvd # 1, Bronx, NY 10466
                      </p>
                    </div>
                    <div class="border-t pt-6">
                      <h4 class="text-lg font-semibold text-gray-900 mb-3">Hours</h4>
                      <div class="space-y-2 text-gray-700 mb-6">
                        <div class="flex justify-between">
                          <span class="font-medium">Mon - Fri:</span>
                          <span>9:00 AM - 5:00 PM</span>
                        </div>
                        <div class="flex justify-between">
                          <span class="font-medium">Sat, Sun:</span>
                          <span class="text-gray-500">Closed</span>
                        </div>
                      </div>
                      <div class="flex flex-col sm:flex-row gap-3 justify-center">
                        <a
                          href="tel:(929) 930-2262"
                          class="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-accent hover:bg-accent/90 transition-colors duration-200"
                        >
                          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                          </svg>
                          Call (929) 930-2262
                        </a>
                        <button
                          @click="scheduleAppt"
                          class="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-accent hover:bg-accent/90 transition-colors duration-200"
                        >
                          <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                          </svg>
                          Schedule Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="relative">
                <img 
                  :src="locationImage" 
                  alt="Regional Neurological Associates Location" 
                  class="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section-container>
  </section>
</template>

<script setup>
import { withQuery } from "ufo";
import locationImage from "~/assets/images/location.jpeg";

const scheduleAppt = () => {
  const { gtag } = useGtag();
  const route = useRoute();
  
  const url = withQuery("https://un6a7rqgzdf.typeform.com/to/WXYVrHcK", {
    ...{
      utm_source: "xxxxx",
      utm_medium: "xxxxx",
      utm_campaign: "xxxxx",
      utm_term: "xxxxx",
      utm_content: "xxxxx",
    },
    ...route.query,
  });

  gtag("event", "schedule_appointment", {
    event_category: "lead",
  });
  
  navigateTo(url, {
    external: true,
    open: {
      target: "_blank",
    },
  });
};
</script>
